var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75764 8.90004C6.23577 9.38817 5.65998 9.31207 5.11115 9.08191C4.52767 8.84712 3.99425 8.83228 3.37802 9.08191C2.61063 9.40115 2.20335 9.30836 1.74118 8.90004C-0.868146 6.31077 -0.483003 2.36654 2.48257 2.21805C3.20182 2.25517 3.7054 2.60133 4.12905 2.6301C4.75875 2.50667 5.3615 2.15309 6.03546 2.19949C6.84527 2.26259 7.45089 2.57071 7.85527 3.12475C6.18952 4.08993 6.58434 6.20586 8.11429 6.79983C7.80809 7.57474 7.41524 8.34044 6.75665 8.90653L6.75764 8.90004ZM4.07128 2.19021C3.99328 1.03942 4.96095 0.0928054 6.07401 0C6.22708 1.32711 4.8223 2.32014 4.07128 2.19021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.24bab6a31f9cd9c2ce0d7445100547f5.svg";
export { ForwardRef as ReactComponent };